// eslint-disable-next-line no-restricted-imports
import { AnalyticsContext as AkAnalyticsContext } from '@atlaskit/analytics-next';
import React from 'react';
export const MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE = 'marketplaceCtx';

const MarketplaceAnalyticsContext = props => {
  const {
    attributes = {},
    properties = {},
    children
  } = props;
  return /*#__PURE__*/React.createElement(AkAnalyticsContext, {
    data: {
      [MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE]: {
        attributes,
        properties
      }
    }
  }, children);
};

export default MarketplaceAnalyticsContext;